#import "../../../../../../common/graphql/ApprovalMapFields.graphql"
query PurchaseOrderPreviewApprovalMap($entityId: UUID!) {
  purchaseOrderPreviewApprovalMap(
    entityId: $entityId
    orderBy: SORT_ORDER_DESC
  ) {
    nodes {
      ...ApprovalMapFields
    }
  }
}
